import { FormatNumberOptions, useIntl } from 'react-intl';

export const useFormatPercent = (
  options: FormatNumberOptions = { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 }
) => {
  const intl = useIntl();
  return (percent: number) => intl.formatNumber(percent, options);
};
